import Cookies from 'js-cookie';
import { useCallback, useEffect, useRef, useState } from 'react';

import { useDispatch, useSelector } from '../../../react-redux';
import { setCustomerTagList, setCustomerTagMap, setCustomerTagTree } from '../../../reducers/tag';
import {
  getCategoryList,
  getCustomerTagApi,
  addCustomerTagApi,
  removeCustomerTagApi,
  updateCustomerTagApi
} from '../api';
import { convertTagMap, convertTagTree } from '@/utils';

const entId = window.parseInt(Cookies.get('_enterprise_id'));

// 节流
window.getCustomerTagThrotte = null;

let currentRequest;

const useCustomerTag = () => {
  const [loading, setLoading] = useState(false);
  const customerTagTree = useSelector(state => state.getIn(['tag', 'customerTagTree']));
  const customerTagList = useSelector(state => state.getIn(['tag', 'customerTagList']));
  const customerTagMap = useSelector(state => state.getIn(['tag', 'customerTagMap']));
  const dispatch = useDispatch();
  const isMounted = useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const getCustomerTree = () => Promise.all([getCategoryList(2), getCustomerTagApi()]);

  const handleGetCustomerTag = useCallback(() => {
    const request = currentRequest || getCustomerTree();
    currentRequest = request;
    setLoading(true);
    return request
      .then(([list, tags]) => {
        dispatch(setCustomerTagTree(convertTagTree(list, tags)));
        dispatch(setCustomerTagList(tags));
        dispatch(setCustomerTagMap(convertTagMap(tags)));
      })
      .finally(() => {
        if (isMounted.current) {
          setLoading(false);
        }
        currentRequest = null;
      });
  }, []);

  useEffect(() => {
    handleGetCustomerTag();
  }, []);

  return {
    customerTagTree,
    customerTagList,
    customerTagMap,
    handleGetCustomerTag,
    addCustomerTagApi,
    removeCustomerTagApi,
    updateCustomerTagApi,
    loading
  };
};

export default useCustomerTag;
